<!--修改密码-->
<template>
    <el-dialog
            title="修改密码"
            :visible.sync="dialogVisible"
            width="540px"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body>
        <el-form ref="form" label-width="100px" @submit.prevent="submit">
            <el-form-item label="旧密码">
                <el-input class="b10" type="password" size="large" onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="oldPassword"
                          placeholder="旧密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
                <el-input class="b10" type="password" size="large" onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="newPassword"
                          placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码">
                <el-input class="b10" type="password" size="large" onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="newPasswordRepeat"
                          placeholder="确认新密码"></el-input>
            </el-form-item>
        </el-form>
        <div class="flex-center">
            <el-button plain @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submit">确认</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">
    import Blowfish from 'blowfish'

    export default {
        name: 'EditPasswordDialog',
        props: ['successCallback'],
        data() {
            return {
                dialogVisible: false,
                oldPassword: '',
                newPassword: '',
                newPasswordRepeat: '',
            }
        },
        watch: {
            dialogVisible(newVal, oldVal) {
                if (newVal == false) {
                    Object.assign(this.$data, this.$options.data())
                }
            }
        },
        methods: {

            // 显示弹出层
            setMaskVisible(val, data) {
                this.dialogVisible = val
            },

            //
            submit() {
                let oldPassword = this.oldPassword,
                    newPassword = this.newPassword,
                    newPasswordRepeat = this.newPasswordRepeat

                if (!oldPassword || (oldPassword.length == 0)) {
                    this.$alert("请输入旧密码！")
                    return;
                }

                if (!newPassword || (newPassword.length == 0)) {
                    this.$alert("请输入新密码！")
                    return;
                }
                if (newPassword != newPasswordRepeat) {
                    this.$alert("两次输入的新密码不同，请确认后重新输入！")
                    return;
                }

                if (oldPassword.match(/^\s*$/)) {
                    this.$alert("请输入新密码！")
                    return;
                }

                if (newPassword.match(/^\s*$/)) {
                    this.$alert("请输入新密码！")
                    return;
                }

                axios.post(Urls.URL.change_password,{newPassword,oldPassword}).then(res => {
                    if(res.data.success) {
                        this.$store.dispatch("setToken", null)
                        this.$store.dispatch("setUserInfo", null)
                        this.$router.replace({name: 'Login'})
                    }
                    this.dialogVisible = false
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

        }
    }
</script>

<style scoped lang="stylus">
    .flex-center {
        width: 100%
        display: flex
        justify-content: center
        button {
            width 20%
            margin-right 20px
        }
    }
</style>
